/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_ProducersInputs */

const en_manage_producers = /** @type {(inputs: Manage_ProducersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Producers`)
};

const es_manage_producers = /** @type {(inputs: Manage_ProducersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrar productores`)
};

/**
* | output |
* | --- |
* | "Manage Producers" |
*
* @param {Manage_ProducersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const manage_producers = /** @type {((inputs?: Manage_ProducersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_ProducersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manage_producers(inputs)
	return es_manage_producers(inputs)
});